import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useRouter } from 'next/router';
import { useDisclosure } from '@chakra-ui/react';
import { getActiveLocaleCurrency } from '../../utils';
const ComposableContext = React.createContext(undefined);
export const FALLBACK_LOCALE = 'en-US';
export const FALLBACK_CURRENCY = 'USD';
export const queryParamsToString = (params) => {
    if (!params)
        return '';
    return Object.keys(params)
        .map((key) => key + '=' + params[key])
        .join('&');
};
export const ComposableProvider = ({ children, intl, getSiteConfig, appKey, }) => {
    const router = useRouter();
    const currentLocale = router?.locale || router?.defaultLocale || FALLBACK_LOCALE;
    const cartDrawer = useDisclosure();
    const megaDrawer = useDisclosure();
    const accountDrawer = useDisclosure();
    const currency = getActiveLocaleCurrency({
        activeLocale: currentLocale,
        intlConfig: intl,
    }) || FALLBACK_CURRENCY;
    const path = React.useRef({
        getAccountDashboard: (params) => `/account/dashboard/${params?.page ? params.page : ''}`,
        getAccountForgot: () => '/account/forgot',
        getAccountReset: () => '/account/reset',
        getAccountLogin: (params) => `/account/login${params ? '?' + queryParamsToString(params) : ''}`,
        getAccountRegister: () => '/account/register',
        getCart: () => '/cart',
        getCheckout: () => '/checkout',
        getCheckoutSuccess: (params) => `/checkout/success?order=${params.order}`,
        getHome: () => '/',
        getPDP: (params) => `/product/${params.slug}`,
        getPLP: (params) => `/category/${params.slug}`,
        getSearch: (params) => `/search?query=${params.query}`,
    });
    const setLocaleHandler = React.useCallback((locale) => {
        const { pathname, asPath, query } = router;
        router.push({ pathname, query }, asPath, { locale });
    }, [router]);
    return (_jsx(ComposableContext.Provider, { value: {
            path: path.current,
            locale: currentLocale,
            cartDrawer,
            megaDrawer,
            accountDrawer,
            intl,
            setLocale: setLocaleHandler,
            currency,
            getSiteConfig,
            appKey: appKey || '',
        }, children: children }));
};
export const useComposable = () => {
    const context = React.useContext(ComposableContext);
    if (context === undefined) {
        throw new Error('useComposable must be used within a ComposableProvider');
    }
    return context;
};
